// extracted by mini-css-extract-plugin
export default {"main":"Offer_main__KgLgw","offertItems":"Offer_offertItems__N5tam","buttonFlex":"Offer_buttonFlex__14XtY","new":"Offer_new__I9sKT"};